var _defs, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeFolderCollection48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.0482,
    y1: -4.9518,
    x2: 37,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4.5,
    y1: 9.5,
    x2: 43.5,
    y2: 48.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad_2",
    "data-name": "Dark Blue Grad 2",
    x1: 11.2322,
    y1: 24.6967,
    x2: 36.7678,
    y2: 50.2322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74b3c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1774,
    stopColor: "#6badc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#539cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8215,
    stopColor: "#2c829c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#177490"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4806,8.5l-3.2134-6.1732c-.3499-.5166-.939-.8268-1.5699-.8268H2.3867c-1.042,0-1.8867.8313-1.8867,1.8568v10.1432h47v-5h-30.0194Z",
    fill: "url(#linear-gradient)",
    stroke: "#464646",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 13.5,
    width: 47,
    height: 31,
    fill: "url(#linear-gradient-2)",
    stroke: "#464646",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,30.5v16h7v-14h19v14h7v-16c0-2.7614-2.2386-5-5-5H12.5c-2.7614,0-5,2.2386-5,5Z",
    fill: "url(#Dark_Blue_Grad_2)",
    stroke: "#464646",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFolderCollection48);
export default __webpack_public_path__ + "static/media/typeFolderCollection48.fcaa7b8099d3b578d36330e843db0dda.svg";
export { ForwardRef as ReactComponent };